export const DragAndDropTypes = {
  RULELISTING: 'RuleListing'
};
